<template>
  <div>
    <Suspense>
      <template #default>
        <router-view></router-view>
      </template>

      <template #fallback>
        <div>Loading all invoices..</div>
      </template>
    </Suspense>
  </div>
</template>

<script setup lang="ts">
//import InvoicesTable from './Invoices-table.vue';
</script>
